import { useState, useCallback } from 'react';
// @mui
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hook';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import { useSnackbar } from 'src/components/snackbar';
// types
import { LoSam, LoSamApi } from 'src/types/losam';
// api
import { losamApiService } from 'src/api/vuontrong-api';
import { useLoSam } from '../hooks/use-losam';
// sections
import LoSamNewEditForm from '../losam-new-edit-form';

// ----------------------------------------------------------------------

export default function NewLoSamView() {
  const router = useRouter();
  const settings = useSettingsContext();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const { addLoSam } = useLoSam();

  const handleSave = useCallback(
    async (data: Partial<LoSamApi>, file?: File) => {
      try {
        setLoading(true);
        // Ensure trangThai is set from is_public mapping (1 active, 2 inactive)
        const payload: LoSamApi = {
          ...data,
          trangThai: data.trangThai ?? 1,
          vuonTrong_ID: data.vuonTrong_ID || 0,
        } as LoSamApi;

        // NOTE: Requires data.vuonTrong_ID to be present
        const response = await addLoSam(payload, file);
 
        if (response.messCode === 1) {
          enqueueSnackbar('Tạo lô sâm thành công!', { variant: 'success' });
          router.push(paths.dashboard.losam.root);
        } else {
          enqueueSnackbar(response.message || 'Có lỗi xảy ra khi tạo lô sâm', { variant: 'error' });
        }
      } catch (error) {
        console.error('Error creating LoSam:', error);
        enqueueSnackbar('Có lỗi xảy ra khi tạo lô sâm', { variant: 'error' });
      } finally {
        setLoading(false);
      }
    },
    [enqueueSnackbar, router, addLoSam]
  );

  const handleClose = useCallback(() => {
    router.push(paths.dashboard.losam.root);
  }, [router]);

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Tạo lô sâm mới"
        links={[
          { name: 'Dashboard', href: paths.dashboard.root },
          { name: 'Lô sâm', href: paths.dashboard.losam.root },
          { name: 'Tạo mới' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <LoSamNewEditForm
        onClose={handleClose}
        onSave={handleSave}
      />
    </Container>
  );
}
